/*global $ */
import ko from 'knockout';

export function registerComponent() {
  ko.components.register('geography-picker', {
    template: { element: 'geography-picker-template' },
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new GeographyPickerViewModel(params, componentInfo);
      },
    },
  });
}

function GeographyPickerViewModel(params, componentInfo) {
  var self = this;

  self.Geographies = params.Geography.Geographies;
  self.ShowAlternativeGeographies = params.Geography.ShowAlternativeGeographies;
  self.Errors = params.Geography.Errors;
  self.AlternativeGeographies = params.Geography.AlternativeGeographies;
  self.AutoCompleteAction = params.Geography.AutoCompleteAction;
  self.content = ko.observable();
  setContent();

  self.Geographies.subscribe(setContent);
  self.AlternativeGeographies.subscribe(setContent);

  function setContent() {
    if (self.Geographies().length > 0) {
      var geo = self.Geographies()[0].Geography();
      for (var i = 0; i < self.AlternativeGeographies().length; i++) {
        var altGeo = self.AlternativeGeographies()[i].Geography();
        if (altGeo) {
          geo += ' + ' + altGeo;
        }
      }

      if (geo) {
        self.content(geo);
      } else {
        self.content('Heel Denemarken');
      }
    } else {
      self.content('&nbsp;');
    }
  }

  self.selectMapGeography = function (id, name) {
    // Her finder vi et hoved emne og hvis det allerede er valgt, så fjerner vi det
    if (self.Geographies().some(g => g.Id() === id)) {
      self.Geographies()[0].Id('');
      self.Geographies()[0].Geography('');
      $(componentInfo.element).trigger('change');
      return;
    };

    // Hvis emnet er valgt som alternativ, så fjerner vi det derfra
    var alternativeGeoIndex = self.AlternativeGeographies().findIndex(g => g.Id() === id);
    if (alternativeGeoIndex >= 0) {
      self.AlternativeGeographies()[alternativeGeoIndex].Id('');
      self.AlternativeGeographies()[alternativeGeoIndex].Geography('');
      $(componentInfo.element).trigger('change');
      return;
    };

    // Hvis vi har mindst et alternativt emne.
    if (self.AlternativeGeographies().length > 0) {
      var lastIndex = self.AlternativeGeographies().length - 1;
      self.AlternativeGeographies()[lastIndex].Id(id);
      self.AlternativeGeographies()[lastIndex].Geography(name);
      self.AlternativeGeographies()[lastIndex].GeographyLong(name);
      $(componentInfo.element).trigger('change');
      return;
    }

    // Hvis vi ikke har et hoved emne, så sætter vi det
    self.Geographies()[0].Id(id);
    self.Geographies()[0].Geography(name);
    self.Geographies()[0].GeographyLong(name);
    $(componentInfo.element).trigger('change');
  };

  self.hasError = ko.pureComputed(function () {
    return self.Errors().length > 0;
  }, self);

  self.activeGeographyIds = ko.pureComputed(function () {
    return self.Geographies().map(g => g.Id()).concat(self.AlternativeGeographies().map(g => g.Id()));
  }, self);
}
